import React from 'react';
import { withRouter } from 'react-router';
import Translate from 'react-translate-component';
import { Button } from 'antd';
import { withSagas } from 'react-async-client';
import { take } from 'redux-saga/effects';

import { LOCATION_CHANGE } from 'constants/actionTypes';
import * as routes from 'constants/routes';

const RoutesErrorRender = withRouter(
    withSagas([
        function* (getProps) {
            yield take(LOCATION_CHANGE);

            const { reset } = getProps();
            reset();
        }
    ])(
        ({ history: { push }, reset }) => (
            <div className="catched-error start-page">
                <Translate content="errors.couldNotOpenPage" component="h3" className="m-b-15 m-t-20" />
                <Button
                    onClick={() => {
                        push(routes.main.stringify());
                        reset();
                    }}
                    type="blue"
                >
                    <Translate content="errors.toStartPage" />
                </Button>
            </div>
        )
    )
);

const RoutesError = (reset) => <RoutesErrorRender reset={reset} />;

export default RoutesError;
